// Keeps the site-wide free-shipping meter in sync with the cart.
//
// The cart drawer and cart page re-render server-side, so their copy of this
// meter needs no JS. The global strip lives in layout/theme.liquid, outside any
// section that Shopify re-renders, so it has to repaint itself.
//
// The theme fires 'shopify:cart:lines-update' with an event.promise. That
// promise's payload shape is not guaranteed to carry a subtotal, so we re-read
// /cart.js instead of trusting it -- one small request, always correct.
(function () {
  const root = document.querySelector('[data-ss-ship]');
  if (!root) return;

  const threshold = Number(root.dataset.ssThreshold) || 6500;
  const label = root.querySelector('[data-ss-ship-label]');
  const track = root.querySelector('[data-ss-ship-track]');
  const fill = root.querySelector('[data-ss-ship-fill]');
  const amount = root.querySelector('[data-ss-ship-amount]');
  const toggle = root.querySelector('[data-ss-ship-toggle]');

  // Mirrors the shop's money format rather than hardcoding "$".
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  // Collapsed tab: whole dollars, rounded up, so it never understates.
  const moneyShort = (cents) => {
    const dollars = Math.ceil(cents / 100);
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(dollars);
    } catch (e) {
      return '$' + dollars;
    }
  };

  const paint = (cart) => {
    const count = cart?.item_count ?? 0;
    if (count === 0) {
      root.hidden = true;
      return;
    }
    const subtotal = cart.total_price ?? 0;
    const remaining = threshold - subtotal;
    const pct = remaining > 0 ? Math.floor((subtotal * 100) / threshold) : 100;

    root.hidden = false;
    root.classList.toggle('ss-ship--done', remaining <= 0);
    label.innerHTML =
      remaining > 0
        ? `<strong>${money(remaining)}</strong> to free standard shipping`
        : '<strong>Free standard shipping</strong> unlocked';
    if (amount) amount.textContent = remaining > 0 ? moneyShort(remaining) : 'Free';
    fill.style.width = pct + '%';
    track.setAttribute('aria-valuenow', String(pct));
  };

  // Collapse/expand. The snippet's inline script sets the initial state before
  // first paint; this only handles shopper input and persisting the choice.
  toggle?.addEventListener('click', () => {
    const min = root.classList.toggle('ss-ship--min');
    toggle.setAttribute('aria-expanded', String(!min));
    try {
      localStorage.setItem('ss-ship-min', min ? '1' : '0');
    } catch (e) {
      /* private mode / blocked site data: the toggle still works, it just
         won't be remembered on the next page. */
    }
  });

  let inFlight = null;
  const refresh = () => {
    inFlight?.abort();
    inFlight = new AbortController();
    fetch('/cart.js', { signal: inFlight.signal })
      .then((r) => r.json())
      .then(paint)
      .catch((err) => {
        if (err?.name !== 'AbortError') console.warn('[ss-ship]', err);
      });
  };

  document.addEventListener('shopify:cart:lines-update', refresh);
  // Back/forward cache can restore a stale cart state.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) refresh();
  });
})();
